module.exports = __webpack_public_path__ + "img/iso_menu.d8b4d28f.png";